import { render } from "./EditPencil.vue?vue&type=template&id=13b780a9"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/EditPencil.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13b780a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13b780a9', __exports__)) {
    api.reload('13b780a9', __exports__)
  }
  
  module.hot.accept("./EditPencil.vue?vue&type=template&id=13b780a9", () => {
    api.rerender('13b780a9', render)
  })

}


export default __exports__